module.exports = __webpack_public_path__ + "static/media/1009269.0c7fc3d9.jpg";